import { setCookie, formatAsNumber, items, smoothScrollTo } from './functions';
import Typed from 'typed.js';

var landingPageTitle = document.title;
var landingHref = location.href;
var referrer = document.referrer;
var search = ["Google","Bing","Yahoo","Yandex"];
var current_scroll = 0;

if (referrer.search("controlyours") < 0) {

	for(var i = 0; i < search.length; i++) {

		if ( referrer.search(search[i].toLowerCase() ) >= 0) {
			setCookie( 'referred_from', search[i], 3 );
			setCookie( 'initial_landing_page', JSON.stringify({title: landingPageTitle, url: landingHref}), 3 );
		}

	}

}

function cyFixedNav() {
	var scroll = current_scroll;
	var navHeight = jQuery('nav.navbar').outerHeight();

		// Header is NOT transparent
		if (jQuery('nav.navbar.nav-not-transparent').length) {
			jQuery('#page-wrapper, #page').css( {marginTop: navHeight+'px'});
			jQuery('nav.navbar').addClass('bg-white shadow-sm');
		// Header IS transparent
		} else {

			if (scroll >= 1) {

				jQuery('nav.navbar').addClass('bg-white shadow-sm');

			} else {

				if ( !jQuery('.nav-open').length ) {
					jQuery('nav.navbar').removeClass('bg-white shadow-sm');
				}

			}

		}
	
}

jQuery(window).on('scroll', function(){
	current_scroll = jQuery(window).scrollTop();

	cyFixedNav();

});

(function($) {
	$(document).on('ready', function(){
		current_scroll = jQuery(window).scrollTop();
		cyFixedNav();

		$('body').on('mouseenter mouseleave','.dropdown',function(e){
			var _d=$(e.target).closest('.dropdown');_d.addClass('show');
			setTimeout(function(){
			_d[_d.is(':hover')?'addClass':'removeClass']('show');
			$('[data-toggle="dropdown"]', _d).attr('aria-expanded',_d.is(':hover'));
			},300);
		});

		if ($('[data-toggle="popover"]').length > 0){
			var popoverPlacement = $(window).outerWidth() <= 767 ? 'auto' : 'left';
			$('[data-toggle="popover"]').popover({html: true,animation:false, placement: popoverPlacement})
		}

		// Nav dropdown background color when open/close
		$('#navbarNavDropdown').on('show.bs.collapse', function () {
			if (!$('nav.navbar').hasClass('fixed-top') || current_scroll == 0 ) {
				$('nav.navbar').addClass('bg-white');
			}
			$('nav.navbar').addClass('nav-open');
		})
		$('#navbarNavDropdown').on('hide.bs.collapse', function () {
			if ($('.navbar').hasClass('.nav-transparent') && current_scroll == 0) {
				$('nav.navbar').removeClass('bg-white');
			}
			$('nav.navbar').removeClass('nav-open');
		})


		if ( jQuery('#whether-you-need').length > 0 ) {
			var typedOptions = {
				strings: ["a website", "online marketing", "a logo", "business cards", "blog posts"],
				typeSpeed: 100,
				backSpeed: 50,
				loop: true,
				backDelay: 2000
			}
			new Typed('#whether-you-need', typedOptions);
		}

		// Show/Hide Chat/Call section based on time of day
		var now = new Date();
		var currentHour = now.getHours();
		if (currentHour >= 9 && currentHour < 17) {
			$('.call-or-chat').show();
			$('.schedule-calendly').hide();
		}

		$('.cy-initiate-chat').on('click', function(e){
			e.preventDefault();
			if (typeof Beacon == 'function') {
				Beacon('open');
			}
		})


		// ScrollTo elements on click
		$('a.scrollTo').on('click', function (e) {
			const link = this;

			// Only handle same-page links
			if (
				location.pathname.replace(/^\//, '') !== link.pathname.replace(/^\//, '') ||
				location.hostname !== link.hostname
			) {
				return;
			}

			const $link = $(link);
			const hash = link.hash;

			if (!hash) return;

			const $target = $(hash).length
				? $(hash)
				: $(`[name="${hash.slice(1)}"]`);

			if (!$target.length) return;

			e.preventDefault();

			const navHeight = $('#wrapper-navbar nav').outerHeight() || 0;
			const targetTop = $target.offset().top - navHeight;

			$target.attr('tabindex', '-1').focus({ preventScroll: true });
			smoothScrollTo(targetTop);
		});

		// Scroll to opened tab on digital advertising page
		if ( $('#marketingTabs-tabs').length > 0 ) {

			var marketingTabsClasses = $('#marketingTabs-tabs').attr('class');
			$('#marketingTabs-tabs').addClass($('#marketingTabs-tabs .nav-link.active').attr('id'));
			$('#marketingTabs-tabs a.nav-link').on('shown.bs.tab', function(e){
				
				$('#marketingTabs-tabs').attr('class', marketingTabsClasses).addClass($(this).attr('id'));
				var href = $(this).attr('href');
				
				if ($(window).outerWidth() < 992) {
					$('html, body').animate({
						scrollTop: $(href).offset().top - ( $('#wrapper-navbar nav').outerHeight() + $(this).outerHeight())
					}, 1000);
				}

			});

		}

		// Home page client testimonials slider

		if (jQuery('#home_client-testimonials').length) {
			tns({
				container: '#home_client-testimonials > div',
				mode: 'carousel',
				speed: 0,
				mouseDrag: true,
				navPosition: 'bottom',
				autoplayButtonOutput: false,
				autoplayTimeout: 12000,
				items: 1,
				slideBy: 'page',
				autoplay: true
			});
		}

		if (jQuery('#about_team-questions').length) {
			tns({
				container: '#about_team-questions',
				mode: 'carousel',
				speed: 0,
				mouseDrag: true,
				navPosition: 'bottom',
				autoplayButtonOutput: false,
				items: 1,
				slideBy: 'page',
				autoplay: false
			});
		}

		if (jQuery('.portfolio-phone-slider').length) {
			tns({
				container: '.portfolio-phone-slider',
				nav: false,
				edgePadding: 25,
				gutter: 25,
				autoplay: true,
				autoplayButtonOutput: false,
				responsive: {
					768: {
						edgePadding: 50,
						gutter: 50
					}
				}
			});
		}
		
		// Populate pricing
		$('.base-membership-price').replaceWith(formatAsNumber.format(items.website_membership.basicMembership.price));
		$('.extra-one-hour-price').replaceWith(formatAsNumber.format(items.support.oneHour.price));
		$('.extra-two-hours-price').replaceWith(formatAsNumber.format(items.support.twoHours.price));
		$('.extra-four-hours-price').replaceWith(formatAsNumber.format(items.support.fourHours.price));
		$('.hourly-price').replaceWith(formatAsNumber.format(items.support.hourly.price));
		$('.additional-domain-price').replaceWith(formatAsNumber.format(items.membershipDetails.domains.price));
		$('.additional-email-price').replaceWith(formatAsNumber.format(items.membershipDetails.emails.price));
		$('.ecommerce-price').replaceWith(formatAsNumber.format(items.membershipDetails.eCommerce.price));
		$('.facebook-campaign-price').replaceWith('$'+formatAsNumber.format(items.facebook.facebookCampaign.price));
		$('.facebook-management-price').replaceWith('$'+formatAsNumber.format(items.facebook.facebookManagement.price)+'/mo');
		$('.google-campaign-price').replaceWith('$'+formatAsNumber.format(items.google.googleCampaign.price));
		$('.google-management-price').replaceWith('$'+formatAsNumber.format(items.google.googleManagement.price)+'/mo');


		$('input[type="tel"]').inputmask({"mask": "(999) 999-9999"});

	});
})(jQuery);